<template>
  <div  >
    <Header></Header>
    <Title title="人员统计"></Title>
    <div class="contain_main">
      <div class="search" @keydown.enter="changepage(1)">
        <div class="search_item">
          <div class="item">
            <span>员工姓名:</span>
            <Input v-model="data.name" placeholder="请输入..." style="width:2rem"/>
          </div>
          <div class="item">
            <span>员工ID:</span>
            <Input v-model="data.userid" placeholder="请输入..." style="width:2rem"/>
          </div>
          <div class="item">
            <Button @click="model=true" type="primary" size="small">选择部门/组织</Button>
          </div>
          <div class="item">
            <div class="button" @click="changepage(1)">搜索</div>
          </div>
        </div>
      </div>
      <div class="table">
        <table>
          <thead>
            <tr>
              <td>员工ID</td>
              <td>姓名</td>
              <td>在职状态</td>
              <td>所属部门</td>
              <td>考试记录</td>
              <td>操作</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in list" :key="index">
              <td>{{item.id}}</td>
              <td>{{item.name}}</td>
              <td>{{item.status|status}}</td>
              <td>{{item.departmentname}}</td>
              <td>{{item.total}}</td>
              <td>
                <button class="pri" @click="$router.push('/joinexamslist?id='+item.id)">查看详情</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="page" style="text-align:right;margin-top:20px;">
        <Page
          :total="total"
          :current='data.page'
          @on-change="changepage"
          @on-page-size-change="changesize"
          show-sizer
          show-elevator
          show-total
          :page-size-opts="[5,10, 20,50]"
        />
      </div>
    </div>
    <Modal v-model="model" title="请选择部门或组织">
      <Tree
        style="max-height:400px;overflow-y:auto"
        :data="orglist"
        @on-check-change="checkdata"
        show-checkbox
        multiple
      ></Tree>
      <div slot="footer">
        <Button type="error" size="large" @click="model=false">关闭</Button>
      </div>
    </Modal>
    <div style="height:100px;"></div>
  </div>
</template>
<script>
import Header from "../../components/header";
import Title from "../../components/title";
import { ExamStatistics_person, Organize_index } from "../../assets/js/api.js";
export default {
  name: "testlist",
  data() {
    return {
      list: [],
      data: {
        name: " ", //	string	true	普通参数		用户编号
        userid: " ", //	string	true	普通参数		用户姓名
        examsid: " ", //	string	true	普通参数		部门id
        page: 1, //	string	true	普通参数		页码
        size: 10 //	string	true	普通参数		条数
      },
      model: false,
      total: null,
      orglist: []
    };
  },
  filters: {
    status(value) {
      switch (value) {
        //1在职、0离职、2实习员工3冻结
        case 0:
          return "离职";
        case 1:
          return "在职";
        case 2:
          return "实习员工";
        case 3:
          return "冻结";  
          
      }
    }
  },
  mounted() {
    this.getlist();
    this.getOrganize();
  },
  components: {
    Header,
    Title
  },
  methods: {
    // 选择组织的函数及对组织数据矫正
    getOrganize() {
      Organize_index().then(res => {
        if (res.data.code == 200) {
          this.orglist = [];
          // 递归遍历 res.data.data
          function rangedata(data) {
            if (data.length > 0) {
              data = data.map(item => {
                var t = {};
                t.expand = false;
                t.orgid = item.orgcode;
                t.title = item.orgname;
                if (item.child) {
                  t.children = rangedata(item.child);
                }
                return t;
              });
              return data;
            } else {
              return;
            }
          }
          this.orglist = rangedata(res.data.data);
        }
      });
    },
    checkdata(data) {
      this.data.examsid = data
        .map(item => {
          return item.orgid;
        })
        .join(",");
    },
    changepage(data) {
      this.data.page = data;
      this.getlist();
    },
    changesize(data) {
      this.data.page = 1;
      this.data.size = data;
      this.getlist();
    },
    getlist() {
      ExamStatistics_person(this.data).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data.list;
          this.total = res.data.data.count;
          return;
        }
        this.$Notice.warning({ title: "信息提示", desc: res.data.message });
      });
    }
  }
};
</script>
<style lang="css" scoped>
/* 搜索栏样式------------------------------------------------------------------------------------------- */
.search {
  margin-top: 0.2rem;
  display: flex;
  color: #575e6b;
}
.search .search_item {
  display: flex;
}
.search .search_item .item {
  margin: 0 0.15rem;
}
.button {
  width: 0.9rem;
  height: 0.3rem;
  color: #fff;
  background: #4b51ff;
  line-height: 0.3rem;
  border-radius: 0.02rem;
  font-size: 0.14rem;
}
/* 表格栏目样式----------------------------------------------------------------------------------------------*/
.table {
  margin-top: 0.6rem;
  font-size: 0.14rem;
}
table {
  width: 100%;
}
thead tr {
  color: #a4acbf;
}
tbody tr {
  color: #707788;
}
tr {
  height: 0.6rem;
}
/*查看详情button-----------------------------------------------------------------------------------------------------------------*/
button {
  border-radius: 0.2rem;
  border: none;
  margin: 0 0.02rem;
  padding: 0.04rem 0.1rem;
  font-size: 0.14rem;
  outline: none;
}
button.blue {
  color: #25b3f9;
  background: #d3f3fc;
}
button.pri {
  color: #e037ff;
  background: #fadfff;
}
button.orange {
  color: #ff8d13;
  background: #ffe2c4;
}
button.green {
  color: #36cd68;
  background: #cffade;
}
button.red {
  color: #ff3a68;
  background: #ffd6de;
}
</style>


// WEBPACK FOOTER //
// src/pages/statistics/userslist.vue